
export default function TheShow() {
  return (
    <section className="py-24 bg-zinc-950 relative overflow-hidden">
      {/* Decorative blur orbs */}
      <div className="absolute top-20 left-10 w-96 h-96 bg-red-600/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-600/10 rounded-full blur-3xl"></div>
      
      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <h2 className="text-4xl font-bold text-center mb-4 text-white">
          The Show
        </h2>
        <p className="text-3xl font-bold text-center mb-16 text-red-600">
          "Unlock Your Mind"
        </p>
        
        <div className="relative">
          {/* Decorative red accent line */}
          <div className="absolute -left-6 top-0 w-1 h-full bg-gradient-to-b from-red-600 via-red-600 to-transparent"></div>
          
          <blockquote className="text-2xl md:text-3xl italic font-serif text-zinc-300 leading-relaxed pl-8">
            Combining mind-reading, psychological illusions, and non-stop audience participation, this 30-60 minute performance is designed to keep students on the edge of their seats. From predicting what a student is thinking to influencing choices in real-time, it's an experience that will be talked about on campus for weeks.
          </blockquote>
        </div>
      </div>
    </section>
  );
}
